import { useMemo, useState } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import {
  PackageInclusionsGroup,
  PackageExtra,
  PackageFooter,
  PackageHeader,
} from '../PackageItems'
import CourseDescriptionPopup from '../../../../popups/CourseDescriptionPopup'

const messages = defineMessages({
  packages: {
    id: 'packages',
    defaultMessage: 'Packages',
  },
  diverPackage: {
    id: 'diver_package',
    defaultMessage: 'Diver package',
  },
  studentPackage: {
    id: 'student_package',
    defaultMessage: 'Student package',
  },
  nonDiverPackage: {
    id: 'non_diver_package',
    defaultMessage: 'Non diver package',
  },
  included: {
    id: 'included',
    defaultMessage: 'Included',
  },
  totalPackagePrice: {
    id: 'total_package_price',
    defaultMessage: 'Total package price',
  },
})

const BookingDetailsResortPackage = ({ order, guestsInRoom }) => {
  const intl = useIntl()

  const [courseId, setCourseId] = useState()
  const [isOpen, setIsOpen] = useState(false)
  const showCourseDetails = (id) => {
    setCourseId(id)
    setIsOpen(true)
  }

  const onClose = () => setIsOpen(false)

  const { divers, students, nonDivers, itemsIncluded } = order
  const diverInclusions = useMemo(() => {
    return itemsIncluded.filter((item) => !item.isStudentApplicable)
  }, [order])
  const studentInclusions = useMemo(() => {
    return itemsIncluded.filter(
      (item) => !item.isDiveCenterExtra || item.isStudentApplicable
    )
  }, [order])
  const nonDiverInclusions = useMemo(() => {
    return itemsIncluded.filter(
      (item) => !item.isDiveCenterExtra && !item.isStudentApplicable
    )
  }, [order])

  const { currency, totalPackagePrice, insurances } = order
  return (
    <div className='price-pan'>
      <PackageHeader
        showQuantity
        title={intl.formatMessage(messages.packages)}
      />

      <div className='price-pan__body'>
        {!!divers && (
          <PackageInclusionsGroup
            title={intl.formatMessage(messages.diverPackage)}
            items={diverInclusions}
            showDives
            quantity={order.divers}
            order={order}
            showCourseDetails={showCourseDetails}
          />
        )}

        {!!students && (
          <PackageInclusionsGroup
            title={intl.formatMessage(messages.studentPackage)}
            quantity={order.students}
            items={studentInclusions}
            showCourseDetails={showCourseDetails}
          />
        )}

        {!!nonDivers && (
          <PackageInclusionsGroup
            title={intl.formatMessage(messages.nonDiverPackage)}
            items={nonDiverInclusions}
            quantity={order.nonDivers}
            showCourseDetails={showCourseDetails}
          />
        )}
        {insurances && !!insurances.length && (
          <PackageExtra
            isInsurance
            item={{
              title: insurances[0].title,
              quantity: insurances[0].quantity,
            }}
            showCourseDetails={showCourseDetails}
          />
        )}
      </div>

      <CourseDescriptionPopup id={courseId} isOpen={isOpen} onClose={onClose} />
      <PackageFooter
        message={intl.formatMessage(messages.totalPackagePrice)}
        currency={currency}
        totalPrice={totalPackagePrice}
        showGuests
        guestsInRoom={guestsInRoom}
      />
    </div>
  )
}

export default BookingDetailsResortPackage
